import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import NotificationsPanel from '../components/notifications/NotificationsPanel';

const NotificationsPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Notifications | Velora Money';
  }, []);

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
        Notifications
      </Typography>
      <NotificationsPanel variant="full" />
    </Box>
  );
};

export default NotificationsPage;
